import { render, staticRenderFns } from "./WdmrSchema.vue?vue&type=template&id=152e2aa8&"
import script from "./WdmrSchema.vue?vue&type=script&lang=js&"
export * from "./WdmrSchema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports